// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T18:12:14.672Z
// Property: Amber Ridge (ID: 6767906449167168)
// Collections: 14 amenities, 5 floorplans (live), 20 photos, 72 POIs, 3 reviews, 4 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167168",
  "property_external_id": "1101826",
  "property_zillow_url": "https://www.zillow.com/apartments/wasilla-ak/amber-ridge/5Xygv3/",
  "property_apartments_url": "https://www.apartments.com/amber-ridge-wasilla-ak/kk9kqy9/",
  "property_google_business_url": "https://www.google.com/maps/place/Amber+Ridge+Apartment+Homes/data=!4m2!3m1!1s0x0:0x37a76a62ba3049?sa=X&ved=2ahUKEwjR__K65YOTAxUVjIkEHTIwAzMQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47708192305",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "amber-ridge-apartments",
  "property_name": "Amber Ridge",
  "property_website_url": "https://alaska.weidner.com/apartments/ak/wasilla/amber-ridge-2/",
  "property_domain": "https://www.amberridgeapartmenthomes.com",
  "property_address": "3235 E Cottle Loop",
  "property_full_address": "3235 E Cottle Loop, Wasilla, AK 99654",
  "property_address_1": "3235 E Cottle Loop",
  "property_address_2": null,
  "property_address_city": "Wasilla",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99654",
  "property_address_country": "US",
  "property_address_county": "Matanuska-Susitna Borough",
  "property_neighborhood_address": "Matanuska Valley",
  "property_address_latitude": "61.58780723120304",
  "property_address_longitude": "-149.3683332507403",
  "property_email": "amberridge@weidner.com",
  "property_phone": "(907) 308-2980",
  "property_call_tracking_phone": "907-308-2980",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Amber Ridge Apartments in Wasilla, AK, comfort meets style with our spacious one and two-bedroom floor plans. Enjoy energy-efficient appliances, stunning granite countertops, and a smoke-free environment. Our open grounds invite relaxation, while our dedicated 24-hour emergency maintenance ensures peace of mind. Find your new home today!",
  "property_long_description": "Welcome to Amber Ridge Apartments, your ideal living destination in scenic Wasilla, AK. Nestled in a serene environment, our community offers a choice of thoughtfully designed floor plans, including one-bedroom and two-bedroom apartments, tailored to meet your unique lifestyle needs. Embrace the luxury of modern living with top-notch amenities that redefine comfort. \n\nAt Amber Ridge, we prioritize your comfort and convenience with features such as 24-hour emergency maintenance and energy-efficient appliances, including Energy Star certified options. Enjoy cooking in your modern kitchen equipped with granite countertops and a dishwasher, while large closets and walk-in closets provide ample storage for all your belongings. Additional perks include luxurious microwaves and pantries in select units to enhance your living experience. \n\nBreathe easy in our smoke-free community, where you can unwind in the open grounds or enjoy stunning views right from your window. Gather friends at your wet bar for entertaining or simply relax in the tranquility of your new home. Whether you're looking for a cozy one-bedroom or a spacious two-bedroom apartment, Amber Ridge Apartments has something special for you. \n\nDiscover the lifestyle you deserve at Amber Ridge. **Find your new home today - browse our availability or schedule a tour to visit our community!** Your dream apartment is just a click away.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-6e38-73c9-bacb-9fc81fea7012.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen with granite countertops, white appliances, and wood cabinets.",
    "public_id": "01a11a16-6e38-73c9-bacb-9fc81fea7012",
    "storage_key": "property/6767906449167168/01a11a16-6e38-73c9-bacb-9fc81fea7012.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "160",
  "property_year_built": "2003",
  "property_year_renovated": null,
  "property_walk_score": "15",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.625",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/amber-ridge-2/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/amber-ridge-2/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/amber-ridge-2/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-83a8-74ea-9270-a1fadf82da56.webp",
  "property_primary_logo_media": {
    "alt_text": "AmberRidge Apartment Homes logo",
    "public_id": "019d021b-83a8-74ea-9270-a1fadf82da56",
    "storage_key": "property/6767906449167168/019d021b-83a8-74ea-9270-a1fadf82da56.webp",
    "width": 1264,
    "height": 525
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021d-a7a5-745b-a34a-1d9b8311ff4e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "AmberRidge Apartment Homes logo.",
    "public_id": "019d021d-a7a5-745b-a34a-1d9b8311ff4e",
    "storage_key": "property/6767906449167168/019d021d-a7a5-745b-a34a-1d9b8311ff4e.webp",
    "width": 640,
    "height": 266
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021d-b1a9-71ea-a215-b56127ea8618.webp",
  "property_mono_black_logo_media": {
    "alt_text": "AmberRidge Apartment Homes logo",
    "public_id": "019d021d-b1a9-71ea-a215-b56127ea8618",
    "storage_key": "property/6767906449167168/019d021d-b1a9-71ea-a215-b56127ea8618.webp",
    "width": 640,
    "height": 266
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#c17a2a",
  "property_secondary_color": "#2b2b2b",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#8a8078",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 1000",
  "property_sqft_min": "537",
  "property_sqft_max": "1000",
  "property_price_range": "930 - 1770",
  "property_price_min": "930",
  "property_price_max": "1770",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/AmberRidgeApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJm93rI4PgyFYRSTC6YmqnNwA",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Amber Ridge Apartments",
  "property_home_romance_title": "Experience Love at First Sight in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Amber Ridge Apartments in Wasilla, AK, where modern living meets stunning comfort. Choose from spacious one and two-bedroom floor plans, featuring energy-efficient appliances and elegant granite countertops. Enjoy open grounds, large closets, and your peaceful sanctuary—complete with 24-hour emergency maintenance for ultimate convenience. ",
  "property_home_floorplans_blurb": "At Amber Ridge Apartments in Wasilla, AK, your ideal living space awaits. With carefully designed floor plans that blend comfort and style, you'll find the perfect layout to suit your lifestyle. Browse our available apartment homes today and step into a welcoming community that feels like home.",
  "property_home_gallery_blurb": "At Amber Ridge Apartments in Wasilla, AK, your ideal home awaits. Choose from thoughtfully designed one- and two-bedroom floor plans featuring modern amenities like granite countertops, energy-efficient appliances, and spacious closets. With 24-hour emergency maintenance and serene grounds, picture yourself living in comfort and style—welcome home!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Wasilla, Amber Ridge Apartments offer a vibrant community surrounded by enriching local attractions. Discover the nearby Wasilla Public Library, breathtaking trails at Crevasse-Moraine, and the fascinating Museum of Alaska Transportation. Enjoy a lifestyle that balances relaxation with adventure, all within your reach.",
  "property_home_reviews_blurb": "At Amber Ridge Apartments in Wasilla, AK, residents rave about the \"welcoming atmosphere and stunning views.\" Experience a vibrant community where neighbors become friends. Curious about life here? Dive into our property reviews to see what makes Amber Ridge a truly special place to call home!",
  "property_neighborhood_blurb": "At Amber Ridge Apartments in Wasilla, AK, your home is surrounded by a vibrant blend of culture and nature. From the Wasilla Public Library and the Alaska Live Steamers Museum to the scenic Crevasse-Moraine Trailhead, there's endless adventure just steps away. Uncover local gems and enrich your lifestyle today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Amber Ridge Apartments, where modern comfort meets serene living in Wasilla, AK. Choose from spacious one or two-bedroom floor plans complemented by energy-efficient appliances, granite countertops, and ample closet space. Enjoy our smoke-free environment and 24-hour emergency maintenance while basking in the beauty of open grounds and stunning views.",
  "property_applynow_blurb": "Welcome to Amber Ridge Apartments in Wasilla, AK, where comfort meets modern living. Choose from thoughtfully designed one and two-bedroom floor plans, featuring spacious layouts, gourmet granite countertops, and energy-efficient appliances. With 24-hour emergency maintenance and smoke-free grounds, your ideal home awaits—apply online today!",
  "property_contactus_blurb": "At Amber Ridge Apartments in Wasilla, AK, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Experience the perfect blend of comfort and convenience in a community that feels like home. Have questions? Our leasing team is here to help—reach out today!",
  "property_faqs_blurb": "At Amber Ridge Apartments in Wasilla, AK, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Curious about community amenities, pet policies, or application processes? Browse our FAQs page for insightful answers that will help you feel right at home in our vibrant community.",
  "property_floorplans_blurb": "At Amber Ridge Apartments in Wasilla, AK, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Each layout balances comfort and style, inviting you to create your ideal living space. Browse our available apartment homes and find the perfect floor plan that feels like home.",
  "property_gallery_blurb": "At Amber Ridge Apartments in Wasilla, AK, each floor plan—one and two bedrooms—offers a blend of comfort and style. Imagine sleek granite countertops, spacious walk-in closets, and energy-efficient appliances defined by modern elegance. With inviting open grounds and 24-hour maintenance, picture yourself living in this smoke-free haven!",
  "property_interactivemap_blurb": "Welcome to Amber Ridge Apartments in Wasilla, AK, where modern living meets comfort. Choose from stylish one or two-bedroom floor plans, each featuring energy-efficient appliances, granite countertops, and spacious walk-in closets. Enjoy our serene open grounds and responsive 24-hour emergency maintenance. Navigate your future home with our interactive community map today!",
  "property_pets_blurb": "At Amber Ridge Apartments in Wasilla, AK, your furry friends are embraced with open arms. With no weight limit and a cozy community tailored for pets, enjoy life alongside your cats and dogs. Bring home up to two pets—your adventure awaits in a space designed for both relaxation and play!",
  "property_referafriend_blurb": "At Amber Ridge Apartments in Wasilla, AK, we believe great friends make the best neighbors. Choose from spacious one or two-bedroom floor plans, perfect for creating shared memories. Invite your friends to join our vibrant community—refer someone today and enjoy the warmth of living close to those who matter most!",
  "property_residentaccess_blurb": "Welcome to Amber Ridge Apartments in Wasilla, AK, where comfortable living meets modern convenience. Our one- and two-bedroom floor plans offer the perfect sanctuary for every lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected to your home sweet home!",
  "property_reviews_blurb": "At Amber Ridge Apartments in Wasilla, AK, residents rave about the vibrant community atmosphere, stating it's \"like living in a cozy retreat.\" Experience the charm and convenience that set our apartments apart. See what our residents have to say about living at our community and find your perfect home!",
  "property_created_at": "1771535426237",
  "property_scheduletour_blurb": "At Amber Ridge Apartments in Wasilla, AK, find your perfect haven with spacious one and two-bedroom floor plans designed for comfort and style. Schedule a tour today and hear firsthand why residents love calling this community home! Your future starts here—come experience the Amber Ridge difference. ",
  "property_thankyou_blurb": "Thank you for reaching out! At Amber Ridge Apartments in Wasilla, AK, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. A member of our team will be in touch soon to guide you toward your perfect home in our welcoming community.",
  "property_virtualtours_blurb": "Welcome to Amber Ridge Apartments in picturesque Wasilla, AK, where comfort meets elegance. Our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of style and functionality. Immerse yourself in your future home—take a virtual tour of our inviting community today and visualize your ideal lifestyle!",
  "property_copyright": "2026 All Rights Reserved. Amber Ridge Apartments",
  "property_seo_title_home": "Amber Ridge Apartments |  Apartments in Wasilla, AK",
  "property_seo_description_home": "Find your perfect sanctuary at Amber Ridge Apartments in Wasilla, AK. Enjoy spacious floor plans, modern amenities, and stunning views—your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Wasilla, AK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Amber Ridge Apartments in Wasilla, AK. Choose from spacious one and two-bedroom floor plans that fit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Wasilla, AK Apartments for Rent",
  "property_seo_description_amenities": "Discover elevated living at Amber Ridge Apartments in Wasilla, AK! Enjoy spacious layouts, energy-efficient appliances, and luxury amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Wasilla, AK",
  "property_seo_description_gallery": "Picture yourself at Amber Ridge Apartments in Wasilla, AK. Spacious one and two-bedroom homes with beautiful views and modern amenities await your arrival!",
  "property_seo_title_virtualtours": "Virtual Tours | Amber Ridge Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Amber Ridge Apartments in Wasilla, AK! Take a virtual tour and envision your future home with spacious one and two-bedroom options.",
  "property_seo_title_interactivemap": "Interactive Map | Amber Ridge Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Amber Ridge Apartments, Wasilla, AK. Enjoy spacious layouts, modern amenities, and a smoke-free community!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wasilla, AK",
  "property_seo_description_neighborhood": "Uncover the charm of Wasilla, AK at Amber Ridge Apartments. Dive into the local scene with hidden gems and favorites just steps from your front door!",
  "property_seo_title_contact": "Contact Us | Amber Ridge Apartments",
  "property_seo_description_contact": "Contact Amber Ridge Apartments in Wasilla, AK! Our friendly team is ready to help with your questions about our one and two-bedroom options.",
  "property_seo_title_faqs": "FAQs | Apartments in Wasilla, AK",
  "property_seo_description_faqs": "Find your perfect home at Amber Ridge Apartments in Wasilla, AK! Check our FAQs for insights on our 1 & 2-bedroom floor plans and community amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wasilla, AK",
  "property_seo_description_reviews": "Discover life at Amber Ridge Apartments in Wasilla, AK. Explore resident reviews and see why our community offers top amenities and spacious layouts!",
  "property_seo_title_applynow": "Apply Now | Apartments in Wasilla, AK",
  "property_seo_description_applynow": "Discover comfort at Amber Ridge Apartments in Wasilla, AK. Choose 1 or 2-bedroom plans with stylish finishes. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Amber Ridge Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Amber Ridge Apartments! Log in to your resident portal to pay rent, request maintenance, and manage your home—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Amber Ridge Apartments",
  "property_seo_description_referafriend": "Great friends make the best neighbors! Refer a friend to Amber Ridge Apartments in Wasilla, AK, and enjoy exclusive rewards together in your new home!",
  "property_seo_title_scheduletour": "Schedule a Tour | Amber Ridge Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Amber Ridge Apartments in Wasilla, AK. Book your tour today and envision your new home surrounded by nature's beauty!",
  "property_seo_title_privacy": "Privacy Policy | Amber Ridge Apartments",
  "property_seo_description_privacy": "Your privacy matters at Amber Ridge Apartments. Uncover how we protect your information and ensure a secure living experience in beautiful Wasilla, AK.",
  "property_seo_title_accessibility": "Website Accessibility | Amber Ridge Apartments",
  "property_seo_description_accessibility": "Experience accessibility at Amber Ridge Apartments in Wasilla, AK. We prioritize digital inclusion for all, ensuring everyone can enjoy our community.",
  "property_seo_title_sitemap": "Sitemap | Amber Ridge Apartments",
  "property_seo_description_sitemap": "Uncover the full essence of Amber Ridge Apartments in Wasilla, AK. Navigate our sitemap to find the perfect home tailored to your lifestyle.",
  "property_seo_title_thankyou": "Thank You | Amber Ridge Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Amber Ridge Apartments in Wasilla, AK! A team member will connect with you soon to assist with your apartment search.",
  "property_seo_title_pets": "Pet Policy | Apartments in Wasilla, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793045546636",
  "amenities": [
    {
      "id": "ec_fa69bcb6f6d0b01986a4a356",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452579",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1aff862700a49fd0b93352d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "120692092",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b66a57f47bbef6281f5e705",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "120692093",
      "title": "Open Grounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d998b0aa564a35f1bdd224bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "124799731",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df5e7c578d83560cb83f26c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452591",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_328fb6e1a0caa76f5de899db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452592",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11f45-7133-7398-87e2-22808712bc09.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wooden cabinets, white microwave, stove, and refrigerator.",
        "public_id": "01a11f45-7133-7398-87e2-22808712bc09",
        "storage_key": "property/6767906449167168/01a11f45-7133-7398-87e2-22808712bc09.webp",
        "width": 1920,
        "height": 1080
      },
      "amenity_image_alt_text": "Amber Ridge Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e3b7551dd93fcd01ff848d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452594",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40033d4ed233aaab3d434ff1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452595",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d9a32-8d58-75f5-bbdc-4871b7ac3c97.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel sink, and wooden cabinets.",
        "public_id": "019d9a32-8d58-75f5-bbdc-4871b7ac3c97",
        "storage_key": "property/6767906449167168/019d9a32-8d58-75f5-bbdc-4871b7ac3c97.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Amber Ridge Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc3d382544ca0581357ae837",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452596",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5508e8ba8d286fae251a7338",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452598",
      "title": "Energy Star Certified Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_baed2f65e0ed48315b542698",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452599",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11f45-7135-743e-80bc-0cbe2d231113.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with granite countertops and stainless steel appliances.",
        "public_id": "01a11f45-7135-743e-80bc-0cbe2d231113",
        "storage_key": "property/6767906449167168/01a11f45-7135-743e-80bc-0cbe2d231113.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Amber Ridge Apartments - Laundry Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fc1665dabc1a2f51b3ecdfb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452600",
      "title": "Pantry*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c444e7908bb3ab08b93fe12b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452601",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb437ffb3bf2d76d17f121f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "yardi",
      "external_id": "87452602",
      "title": "Wet Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_a0f0fe9d67976a46e295ffff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-6e38-73c9-bacb-9fc81fea7012.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, white appliances, and wood cabinets.",
        "public_id": "01a11a16-6e38-73c9-bacb-9fc81fea7012",
        "storage_key": "property/6767906449167168/01a11a16-6e38-73c9-bacb-9fc81fea7012.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, a full suite of white appliances including a refrigerator, stove, and microwave, and ample wood cabinetry for storage. The breakfast bar offers additional counter space and seating.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, white appliances, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (36).JPG"
    },
    {
      "id": "ec_238bed50c8fb6057a04d9156",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a12473-bc6e-765a-8797-d0df3ee0e48b.webp",
      "image_media": {
        "alt_text": "Save up to $250 off move-in on select homes graphic.",
        "public_id": "01a12473-bc6e-765a-8797-d0df3ee0e48b",
        "storage_key": "property/6767906449167168/01a12473-bc6e-765a-8797-d0df3ee0e48b.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Limited time offer: Save up to $250 off move-in on select homes. Restrictions apply. Contact the leasing office for details.",
      "link": "false",
      "alt_text": "Save up to $250 off move-in on select homes graphic.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials (3251).png"
    },
    {
      "id": "ec_71ac66dcf2459bf56f7a549a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-4160-714e-b404-b5ee5bee5694.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel sink, white appliances, and wood cabinets.",
        "public_id": "019d021b-4160-714e-b404-b5ee5bee5694",
        "storage_key": "property/6767906449167168/019d021b-4160-714e-b404-b5ee5bee5694.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, a double sink, white appliances including a microwave, and ample wood cabinetry for storage.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel sink, white appliances, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (33).JPG"
    },
    {
      "id": "ec_422123e1e2335a72bd430942",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-8cd8-759f-b17b-132749c6c622.webp",
      "image_media": {
        "alt_text": "Kitchen and entryway of an apartment with a breakfast bar and two stools.",
        "public_id": "019d021b-8cd8-759f-b17b-132749c6c622",
        "storage_key": "property/6767906449167168/019d021b-8cd8-759f-b17b-132749c6c622.webp",
        "width": 1500,
        "height": 910
      },
      "title": "Apartment",
      "description": "View of a spacious apartment kitchen featuring a breakfast bar with stools, ample cabinet space, a refrigerator, and a view of the entryway.",
      "link": "false",
      "alt_text": "Kitchen and entryway of an apartment with a breakfast bar and two stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (29).jpg"
    },
    {
      "id": "ec_ce7988ef36b2acd53a033147",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-853b-7318-bb28-dca6224a6a23.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
        "public_id": "01a11a16-853b-7318-bb28-dca6224a6a23",
        "storage_key": "property/6767906449167168/01a11a16-853b-7318-bb28-dca6224a6a23.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring wood cabinetry, granite countertops, a microwave, refrigerator, and stove.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (27).JPG"
    },
    {
      "id": "ec_47928d8fa272e7ef623f9301",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-8dbc-7248-b564-c0dc37b9e099.webp",
      "image_media": {
        "alt_text": "Kitchen area with island and bar stools, connected to living space.",
        "public_id": "01a11a16-8dbc-7248-b564-c0dc37b9e099",
        "storage_key": "property/6767906449167168/01a11a16-8dbc-7248-b564-c0dc37b9e099.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring an island with bar stools, perfect for casual dining. This open-concept layout seamlessly connects to the living area, offering a comfortable and inviting atmosphere.",
      "link": "false",
      "alt_text": "Kitchen area with island and bar stools, connected to living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (31).JPG"
    },
    {
      "id": "ec_9ef4fd158f75f92e167c407c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-8414-715d-a7f1-5ecbdea3349b.webp",
      "image_media": {
        "alt_text": "Bright living room with a sectional sofa, coffee table, and window.",
        "public_id": "01a11a16-8414-715d-a7f1-5ecbdea3349b",
        "storage_key": "property/6767906449167168/01a11a16-8414-715d-a7f1-5ecbdea3349b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, a modern coffee table, and ample natural light from a large window. Includes an open doorway to a closet.",
      "link": "false",
      "alt_text": "Bright living room with a sectional sofa, coffee table, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (21).jpg"
    },
    {
      "id": "ec_ffd73fd494d4f769946b9371",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-9463-700a-b56e-b254bd97728b.webp",
      "image_media": {
        "alt_text": "Empty bedroom with mirrored closet doors and doorway to kitchen with bar stools",
        "public_id": "01a11a16-9463-700a-b56e-b254bd97728b",
        "storage_key": "property/6767906449167168/01a11a16-9463-700a-b56e-b254bd97728b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet with mirrored doors and a view into the kitchen area, perfect for comfortable living.",
      "link": "false",
      "alt_text": "Empty bedroom with mirrored closet doors and doorway to kitchen with bar stools",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (34).JPG"
    },
    {
      "id": "ec_60b8fee7916dd07db50e7258",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-94c6-7306-acef-0be32c09ec24.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a large mirrored closet and a vase of flowers.",
        "public_id": "01a11a16-94c6-7306-acef-0be32c09ec24",
        "storage_key": "property/6767906449167168/01a11a16-94c6-7306-acef-0be32c09ec24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large mirrored closet, hardwood floors, and a window with blinds. Perfect for creating your personal sanctuary.",
      "link": "false",
      "alt_text": "Empty bedroom with a large mirrored closet and a vase of flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (32).JPG"
    },
    {
      "id": "ec_1bd9d1cf5040e999c6f2ad8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-a6b1-731c-a325-ebb1f289530c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a window and countertop.",
        "public_id": "01a11a16-a6b1-731c-a325-ebb1f289530c",
        "storage_key": "property/6767906449167168/01a11a16-a6b1-731c-a325-ebb1f289530c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with a well-equipped kitchen, featuring a countertop and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a window and countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (30).JPG"
    },
    {
      "id": "ec_788df3b6d531e97b6adc1898",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-2879-719e-bf73-ba281879219c.webp",
      "image_media": {
        "alt_text": "Closet with sliding wooden door",
        "public_id": "019d021b-2879-719e-bf73-ba281879219c",
        "storage_key": "property/6767906449167168/019d021b-2879-719e-bf73-ba281879219c.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A spacious closet with a sliding wooden door and a built-in shelf and hanging rod. Perfect for storage in any apartment.",
      "link": "false",
      "alt_text": "Closet with sliding wooden door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (26).JPG"
    },
    {
      "id": "ec_fbf6a7385401405b3fadc4fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-34fd-716e-8254-b8504259b7e8.webp",
      "image_media": {
        "alt_text": "Spacious empty room with wood-look flooring and a large window.",
        "public_id": "019d021b-34fd-716e-8254-b8504259b7e8",
        "storage_key": "property/6767906449167168/019d021b-34fd-716e-8254-b8504259b7e8.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "This is a large, empty room featuring beautiful wood-look flooring, white walls, and a large window that lets in plenty of natural light.",
      "link": "false",
      "alt_text": "Spacious empty room with wood-look flooring and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (25).JPG"
    },
    {
      "id": "ec_136717bfac52beb7aa86c888",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-3548-72da-8001-ac590f159cd5.webp",
      "image_media": {
        "alt_text": "Living room and kitchen view of an apartment.",
        "public_id": "019d021b-3548-72da-8001-ac590f159cd5",
        "storage_key": "property/6767906449167168/019d021b-3548-72da-8001-ac590f159cd5.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious living room with wood-look flooring and an open view into the kitchen area.",
      "link": "false",
      "alt_text": "Living room and kitchen view of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (24).JPG"
    },
    {
      "id": "ec_fd5e25c5663fd2b336289519",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-b817-706a-afaf-e81f919162de.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "01a11a16-b817-706a-afaf-e81f919162de",
        "storage_key": "property/6767906449167168/01a11a16-b817-706a-afaf-e81f919162de.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a granite countertop, a toilet, and a bathtub with a shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (28).JPG"
    },
    {
      "id": "ec_76b9f48c8a53eff6589a24d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-bf6d-76db-bd17-a6dc202d3497.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and medicine cabinet.",
        "public_id": "01a11a16-bf6d-76db-bd17-a6dc202d3497",
        "storage_key": "property/6767906449167168/01a11a16-bf6d-76db-bd17-a6dc202d3497.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a white bathtub with a decorative shower curtain, a toilet, and a vanity with a speckled countertop, sink, and a wooden medicine cabinet.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and medicine cabinet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (35).jpg"
    },
    {
      "id": "ec_fd48f7a3b38c7319677def4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-4a65-72c3-8245-3bfee650dc6d.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "019d021b-4a65-72c3-8245-3bfee650dc6d",
        "storage_key": "property/6767906449167168/019d021b-4a65-72c3-8245-3bfee650dc6d.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with washers and dryers for residents.",
      "link": "false",
      "alt_text": "Laundry room with multiple washing machines and dryers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (23).JPG"
    },
    {
      "id": "ec_ddfe62863097f4543ce1b045",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-ba59-711f-9c78-81afa517ee11.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a large window.",
        "public_id": "01a11a16-ba59-711f-9c78-81afa517ee11",
        "storage_key": "property/6767906449167168/01a11a16-ba59-711f-9c78-81afa517ee11.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush queen-size bed, elegant nightstands, and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (22).jpg"
    },
    {
      "id": "ec_f4a4934e6b29bd233a6c1921",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-d99b-700f-9141-0812a5256400.webp",
      "image_media": {
        "alt_text": "Amberbridge apartment complex exterior with stone pillars and a wooden fence.",
        "public_id": "01a11a16-d99b-700f-9141-0812a5256400",
        "storage_key": "property/6767906449167168/01a11a16-d99b-700f-9141-0812a5256400.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Amberbridge apartments, featuring a beautiful exterior with stone pillars and a charming wooden fence.",
      "link": "false",
      "alt_text": "Amberbridge apartment complex exterior with stone pillars and a wooden fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (38).JPG"
    },
    {
      "id": "ec_184a18c44665465fe5d3ddf7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-d311-715f-bd95-e128d3a3b08a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with tan siding and a blue sky with clouds.",
        "public_id": "01a11a16-d311-715f-bd95-e128d3a3b08a",
        "storage_key": "property/6767906449167168/01a11a16-d311-715f-bd95-e128d3a3b08a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of tan apartment buildings set against a backdrop of trees and mountains under a blue sky with fluffy clouds.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with tan siding and a blue sky with clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (37).JPG"
    },
    {
      "id": "ec_3635fafed5bdd5da642ccf82",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a11a16-e6da-7120-8489-5d6a32a3e21a.webp",
      "image_media": {
        "alt_text": "Amberridge Apartment Homes monument sign",
        "public_id": "01a11a16-e6da-7120-8489-5d6a32a3e21a",
        "storage_key": "property/6767906449167168/01a11a16-e6da-7120-8489-5d6a32a3e21a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Amberridge Apartment Homes, featuring a prominent monument sign with the property name.",
      "link": "false",
      "alt_text": "Amberridge Apartment Homes monument sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Amber-Ridge_Favorites (39).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_957f9b77-f5cc-4ace-8558-495e2a308132",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Karma Kafe",
      "poi_type": "Restaurants",
      "poi_address": "3400 E Cottle Loop Ste 800, Wasilla, AK 99654, USA",
      "poi_short_description": "Casual, spacious, gluten-free menu shop serving coffee drinks, pre-packaged meals and gluten-free fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-9eb6-74eb-9d56-49a6cff650c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-9eb6-74eb-9d56-49a6cff650c9",
        "storage_key": "property/6767906449167168/01a140ab-9eb6-74eb-9d56-49a6cff650c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.karmakafeak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9882016187611530874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "karma-kafe",
      "poi_latitude": "61.5857098",
      "poi_longitude": "-149.363701",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-841-5005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9910-769d-950f-b765baff45ed",
        "storage_key": "property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ543knoPhyFYResY-j135I4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_1fef8b4c-a122-4a82-8c8b-8769a8cb3acc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Sherrie’s Vally Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3190 E Meridian Park Loop, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-95a6-70be-a06f-cac3a60fdcf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-95a6-70be-a06f-cac3a60fdcf6",
        "storage_key": "property/6767906449167168/01a140ab-95a6-70be-a06f-cac3a60fdcf6.webp",
        "width": 1171,
        "height": 782
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10560834917818119051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sherries-vally-cafe",
      "poi_latitude": "61.591789899999995",
      "poi_longitude": "-149.3640138",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZHXCgDhyFYRizMXcGefj5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_f5799904-2d1c-49b8-8b39-d41f9f25d68f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Wandering Cafe",
      "poi_type": "Restaurants",
      "poi_address": "344 Main St, Wasilla, AK 99654, USA",
      "poi_short_description": "Cozy family-run cafe serving fresh sandwiches and gourmet soups.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-99f9-778d-8954-084952e0c7c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-99f9-778d-8954-084952e0c7c6",
        "storage_key": "property/6767906449167168/01a140ab-99f9-778d-8954-084952e0c7c6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wanderingcafeak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15237021517622976000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wandering-cafe",
      "poi_latitude": "61.58265300000001",
      "poi_longitude": "-149.4420778",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-521-5751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9910-769d-950f-b765baff45ed",
        "storage_key": "property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJNzN8eXbdyFYRAJ7mUFfGdNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_9f52fd03-95d8-48a4-ac20-445df2fd3834",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Commons Café",
      "poi_type": "Restaurants",
      "poi_address": "231 E Swanson Ave Ste 24, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-9bf6-7599-90c6-a4dbafdb2126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-9bf6-7599-90c6-a4dbafdb2126",
        "storage_key": "property/6767906449167168/01a140ab-9bf6-7599-90c6-a4dbafdb2126.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.thecommonsak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1833003692405375483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-commons-caf",
      "poi_latitude": "61.58334189999999",
      "poi_longitude": "-149.4454053",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-214-1362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9910-769d-950f-b765baff45ed",
        "storage_key": "property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJfcYSIznfyFYR-0HNhSUjcBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_ddfa4bf4-0431-4aff-ab17-d78832b3c3ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Nonna’s Osteria | Italian",
      "poi_type": "Restaurants",
      "poi_address": "201 W Herning Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "Inviting Italian eatery serving fresh house-made pasta and wood-fired pizza.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-95b3-72da-92e1-d1e5ed33f75c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-95b3-72da-92e1-d1e5ed33f75c",
        "storage_key": "property/6767906449167168/01a140ab-95b3-72da-92e1-d1e5ed33f75c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nonnasosteria.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6328612750654588636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nonnas-osteria--italian",
      "poi_latitude": "61.5825439",
      "poi_longitude": "-149.4540824",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-376-2914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_RnJF2vfyFYR3EbGK8S_01c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1a2c2ffc-6274-4b71-a113-6bce37e830bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Evangelo's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2530 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Pizza, pasta, seafood, souvlaki & steaks served in a roomy dining hall with a full bar.",
      "poi_long_description": "Pizza, pasta, seafood, souvlaki & steaks served in a roomy dining hall with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-9664-74ee-9138-a875ef8f5065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-9664-74ee-9138-a875ef8f5065",
        "storage_key": "property/6767906449167168/01a140ab-9664-74ee-9138-a875ef8f5065.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://evangelosrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13325222123355245380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evangelos-restaurant",
      "poi_latitude": "61.5711923",
      "poi_longitude": "-149.3841254",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-376-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdp83qPgyFYRRAvEz-uy7Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ecc8a7b0-910a-4fc0-98d2-86c950c752a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Locals Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3100 E Parks Hwy #99654, Wasilla, AK 99654, USA",
      "poi_short_description": "Relaxed pub and pizza restaurant serving hand-crafted pizza, burgers, and local draft beers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-992f-765f-9459-1ffeec391016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-992f-765f-9459-1ffeec391016",
        "storage_key": "property/6767906449167168/01a140ab-992f-765f-9459-1ffeec391016.webp",
        "width": 1280,
        "height": 618
      },
      "poi_business_url": "https://www.localspizzapub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16043063676793912717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "locals-pub--pizzeria",
      "poi_latitude": "61.570795399999994",
      "poi_longitude": "-149.3737425",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-357-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2THMb3gyFYRjf1FDGpppN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e79d0faa-05bc-44ab-94da-4b0f9cd31767",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Mr. Taco Wasilla",
      "poi_type": "Restaurants",
      "poi_address": "431 W Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Welcoming Mexican restaurant serving authentic street tacos, chimichangas, and a popular salsa bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-99ec-710c-9f3c-19e899ae02aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-99ec-710c-9f3c-19e899ae02aa",
        "storage_key": "property/6767906449167168/01a140ab-99ec-710c-9f3c-19e899ae02aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mrtacoak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1572925158026384883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mr-taco-wasilla",
      "poi_latitude": "61.5828244",
      "poi_longitude": "-149.46000089999998",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-376-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWqjvsDfyFYR8xVw9hgn1BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ccdbddc9-df54-4ad6-9916-687e4968bc1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Marcys",
      "poi_type": "Restaurants",
      "poi_address": "2431 E Old Matanuska Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5282957003921447306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcys",
      "poi_latitude": "61.5712934",
      "poi_longitude": "-149.3866414",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJETYF_gThyFYRillmnmfVUEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "snack_bar"
    },
    {
      "id": "custom_857b0935-6a59-43a2-b08a-75fb747178a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Mat-Su Brew & Bites",
      "poi_type": "Restaurants",
      "poi_address": "1830 E Bogard Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-9a6b-776b-a221-1622adf931ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-9a6b-776b-a221-1622adf931ee",
        "storage_key": "property/6767906449167168/01a140ab-9a6b-776b-a221-1622adf931ee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mat-suresort.com/brewandbites",
      "poi_directions_map_url": "https://maps.google.com/?cid=5902203016967476993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mat-su-brew--bites",
      "poi_latitude": "61.588645799999995",
      "poi_longitude": "-149.4047384",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-357-5252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9910-769d-950f-b765baff45ed",
        "storage_key": "property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQfVxl1jfyFYRAdeVal_W6FE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_714174da-8ea5-46bc-9371-bc968c332898",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Everett's",
      "poi_type": "Restaurants",
      "poi_address": "1850 E Bogard Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "Lakeside fine dining restaurant serving gourmet seafood and steaks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-2f1a-767d-960e-6c900ddc9903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-2f1a-767d-960e-6c900ddc9903",
        "storage_key": "property/6767906449167168/01a140aa-2f1a-767d-960e-6c900ddc9903.webp",
        "width": 1280,
        "height": 927
      },
      "poi_business_url": "https://www.mat-suresort.com/everetts",
      "poi_directions_map_url": "https://maps.google.com/?cid=12179769524939957119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "everetts",
      "poi_latitude": "61.58694440000001",
      "poi_longitude": "-149.40472219999998",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-357-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsTmqUzveyFYRf6MsDNo7B6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_f1144c6c-f902-47a6-b925-cdc62866d525",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Zushi",
      "poi_type": "Restaurants",
      "poi_address": "1731 E Palmer-Wasilla Hwy #200, Wasilla, AK 99654, USA",
      "poi_short_description": "Asian fusion restaurant serving a variety of sushi rolls and bento box meals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-3c4b-7074-be7d-54c3a1dcc7e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-3c4b-7074-be7d-54c3a1dcc7e5",
        "storage_key": "property/6767906449167168/019d021c-3c4b-7074-be7d-54c3a1dcc7e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.zushialaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5250282267535171196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zushi",
      "poi_latitude": "61.5779492",
      "poi_longitude": "-149.4093843",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-373-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcWPCxneyFYRfF73tue_3Eg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_009193e8-5fa0-4dcf-bf57-c66b9871cc95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Perfect Start",
      "poi_type": "Restaurants",
      "poi_address": "1501 W Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Local Alaskan coffee shop offering quality coffee and signature Red Bull smoothies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-9e4c-71f9-a1b9-0ea1540bd549.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-9e4c-71f9-a1b9-0ea1540bd549",
        "storage_key": "property/6767906449167168/01a140ab-9e4c-71f9-a1b9-0ea1540bd549.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://theperfectstartespressos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5720319496677210068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-perfect-start",
      "poi_latitude": "61.57971329999999",
      "poi_longitude": "-149.4894969",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-841-3042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9910-769d-950f-b765baff45ed",
        "storage_key": "property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ9SUnVH7eyFYR1LcvUUaoYk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_2e40fce4-89d6-4746-b891-d6a9a38ce586",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Little Miller's Metro Ice Cream & Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1700 Lucille St, Wasilla, AK 99654, USA",
      "poi_short_description": "Cozy coffee shop serving espresso drinks and soft-serve ice cream.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-a22d-73ba-aa6b-e970e1795d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-a22d-73ba-aa6b-e970e1795d2d",
        "storage_key": "property/6767906449167168/01a140ab-a22d-73ba-aa6b-e970e1795d2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.littlemillersak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13209832760763124459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-millers-metro-ice-cream--coffee",
      "poi_latitude": "61.5983333",
      "poi_longitude": "-149.4516667",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-373-6129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9910-769d-950f-b765baff45ed",
        "storage_key": "property/6767906449167168/019d021c-9910-769d-950f-b765baff45ed.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJE2dvU2neyFYR64qaP-jAUrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_eb00ff1b-9eb4-4010-a726-c2b6205483a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Sicily's Pizza Wasilla",
      "poi_type": "Restaurants",
      "poi_address": "259 McCallister Dr, Wasilla, AK 99654, USA",
      "poi_short_description": "Offering 24-hour delivery, this chain's menu includes pizza, pasta, sandwiches & wings.",
      "poi_long_description": "Offering 24-hour delivery, this chain's menu includes pizza, pasta, sandwiches & wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-a290-703f-81d9-ad900e86a9b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-a290-703f-81d9-ad900e86a9b5",
        "storage_key": "property/6767906449167168/01a140ab-a290-703f-81d9-ad900e86a9b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sicilyspizzawasilla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7328650044280609657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sicilys-pizza-wasilla",
      "poi_latitude": "61.5797621",
      "poi_longitude": "-149.5305904",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-373-8009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIcaLzGzeyFYReRt_7GKYtGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f54ebb5e-1289-4b1f-95b8-ef7ca4a6d1ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "595 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-4132-775a-8eb4-00051e9283b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-4132-775a-8eb4-00051e9283b1",
        "storage_key": "property/6767906449167168/019d021c-4132-775a-8eb4-00051e9283b1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.carrsqc.com/ak/wasilla/595-e-parks-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12888208257321642406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.582602599999994",
      "poi_longitude": "-149.4348587",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-352-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9ef6-76ed-9a3f-ecedebba6bfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9ef6-76ed-9a3f-ecedebba6bfd",
        "storage_key": "property/6767906449167168/019d021c-9ef6-76ed-9a3f-ecedebba6bfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHyiwWBPeyFYRpqnpGCAd3LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a6246333-4c33-47a2-b945-323d4f213454",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "1501 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-421e-75a1-b67d-c6dc1b30cc67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-421e-75a1-b67d-c6dc1b30cc67",
        "storage_key": "property/6767906449167168/019d021c-421e-75a1-b67d-c6dc1b30cc67.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/wasilla/wasilla/701/00653?cid=loc_70100653_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1913930344173969702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.5794418",
      "poi_longitude": "-149.4089019",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-352-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9ef6-76ed-9a3f-ecedebba6bfd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9ef6-76ed-9a3f-ecedebba6bfd",
        "storage_key": "property/6767906449167168/019d021c-9ef6-76ed-9a3f-ecedebba6bfd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wJyCxneyFYRJqFU8YGljxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_df00aba9-4298-42df-85ba-214db073a2d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1350 S Seward Meridian Pkwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Comprehensive department store offering one-stop shopping with groceries and home essentials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-467f-752c-9799-d378f6bdf68c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-467f-752c-9799-d378f6bdf68c",
        "storage_key": "property/6767906449167168/019d021c-467f-752c-9799-d378f6bdf68c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2074-wasilla-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12694119304488895837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.5686987",
      "poi_longitude": "-149.3638387",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-376-9780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990e-729e-8a66-e727e9a3ff6b",
        "storage_key": "property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg35x0L3gyFYRXUV9SECSKrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_bc875691-110d-416d-b85a-1f0805980401",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-a673-73e9-b206-47b3a1a0ce85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-a673-73e9-b206-47b3a1a0ce85",
        "storage_key": "property/6767906449167168/01a140ab-a673-73e9-b206-47b3a1a0ce85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/wasilla/2339",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762347473961702303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "61.57796039999999",
      "poi_longitude": "-149.403722",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-631-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990e-729e-8a66-e727e9a3ff6b",
        "storage_key": "property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCf25UxjeyFYRn1PbUX_4908",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e0a2ef5d-5c3a-4d2d-9d77-63114afd5595",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-662b-736d-8365-807ab02cb3b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-662b-736d-8365-807ab02cb3b6",
        "storage_key": "property/6767906449167168/019d021c-662b-736d-8365-807ab02cb3b6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/wasilla-ak-pharmacies/1801-e-parks-hwy-wasilla-ak-99654/storeid=17404?WT.mc_id=LS_GOOGLE_RX_17404",
      "poi_directions_map_url": "https://maps.google.com/?cid=14965600125999547548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "61.57796039999999",
      "poi_longitude": "-149.403722",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-631-7201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a398-775a-b50f-d7549c685a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a398-775a-b50f-d7549c685a62",
        "storage_key": "property/6767906449167168/019d021c-a398-775a-b50f-d7549c685a62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-vC1BjeyFYRnIS-AAZ-sM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_976d300d-ad64-408e-b7ac-fc1c3cd109b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2561 Sun Mountain Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-de89-7048-8054-d8f22bd3636c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-de89-7048-8054-d8f22bd3636c",
        "storage_key": "property/6767906449167168/019d021c-de89-7048-8054-d8f22bd3636c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/AK-Wasilla/2512?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2512-_-na-_-0-_-0&y_source=1_MTE4NDMzNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7023678612494780161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "61.5734867",
      "poi_longitude": "-149.3851516",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-352-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990e-729e-8a66-e727e9a3ff6b",
        "storage_key": "property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVX0Lg6HgyFYRAYdCKnweeWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_63eb5245-7558-4556-9a7a-abadcb9e80ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1255 E Palmer-Wasilla Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-2743-76df-9445-2f3c6a777f98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-2743-76df-9445-2f3c6a777f98",
        "storage_key": "property/6767906449167168/01a140aa-2743-76df-9445-2f3c6a777f98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Wasilla/AK/Wasilla/99654/1304?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4683517424288517085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "61.5758981",
      "poi_longitude": "-149.41816710000003",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-357-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990e-729e-8a66-e727e9a3ff6b",
        "storage_key": "property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVYQ-bxreyFYR3csRdkgy_0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d48d0e62-9454-4caf-9eb7-17a19cca7fbd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Wagon Wheel Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "701 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Cozy boutique gift shop featuring unique Alaskan finds and an in-store coffee cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-a6cf-717c-aa58-56326c302906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-a6cf-717c-aa58-56326c302906",
        "storage_key": "property/6767906449167168/01a140ab-a6cf-717c-aa58-56326c302906.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wagonwheelmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16305207875618849314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wagon-wheel-marketplace",
      "poi_latitude": "61.581613999999995",
      "poi_longitude": "-149.43394659999998",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-671-0189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990e-729e-8a66-e727e9a3ff6b",
        "storage_key": "property/6767906449167168/019d021c-990e-729e-8a66-e727e9a3ff6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPb2ndP7fyFYRIsIplyy8R-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_3c478503-c9e4-4cbb-a7cb-3e5d37e0529e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "225 N Boundary St, Wasilla, AK 99654, USA",
      "poi_short_description": "Convenience store chain offering breakfast sandwiches, plus coffee and other beverages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-a7a6-75d4-ae4c-d554320d627a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-a7a6-75d4-ae4c-d554320d627a",
        "storage_key": "property/6767906449167168/01a140ab-a7a6-75d4-ae4c-d554320d627a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/wasilla/225-n-boundary-st/2746605?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1751410921861537301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.581625300000006",
      "poi_longitude": "-149.4389891",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-376-2948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990c-76eb-a02a-d4bd7f85f8b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990c-76eb-a02a-d4bd7f85f8b8",
        "storage_key": "property/6767906449167168/019d021c-990c-76eb-a02a-d4bd7f85f8b8.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQ6DuShPeyFYRFd5LPfRCThg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_d439c908-01f8-4454-b3e9-d7bbcd777e2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Speedway Express",
      "poi_type": "Transportation & Transit",
      "poi_address": "211 Main St, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.speedway.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=16205880203495569135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway-express",
      "poi_latitude": "61.581221000000006",
      "poi_longitude": "-149.44091699999998",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-373-0711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-db1f-7201-ab41-2dc5499c65b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ab-db1f-7201-ab41-2dc5499c65b3",
        "storage_key": "property/6767906449167168/01a140ab-db1f-7201-ab41-2dc5499c65b3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJkUGH0GzeyFYR73bjwS7a5uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_f5ae8ffa-5de0-4575-8698-989a822115c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Cottonwood Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "800 N Seward Meridian Pkwy, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-a86d-713f-85dd-18fbae76f5f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-a86d-713f-85dd-18fbae76f5f0",
        "storage_key": "property/6767906449167168/01a140ab-a86d-713f-85dd-18fbae76f5f0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cwe.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13375367426562985196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cottonwood-creek-elementary-school",
      "poi_latitude": "61.588046199999994",
      "poi_longitude": "-149.3623351",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-864-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR8OBi4PgyFYR7AyeCM_Znrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_559b70e5-eae1-4ec9-81ff-f42adc7c95fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Teeland Middle School",
      "poi_type": "Education",
      "poi_address": "2788 N Seward Meridian Pkwy, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-4f64-763f-9f36-967c15eff35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-4f64-763f-9f36-967c15eff35b",
        "storage_key": "property/6767906449167168/019d021c-4f64-763f-9f36-967c15eff35b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tms.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6199755551641388747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teeland-middle-school",
      "poi_latitude": "61.6117096",
      "poi_longitude": "-149.3629503",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-352-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtyUIgdDfyFYRy0bXldP0CVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_690c8f97-5177-4342-9cd6-08257fb15935",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Wasilla High School",
      "poi_type": "Education",
      "poi_address": "701 E Bogard Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-aefa-772b-b430-33576aeeba07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-aefa-772b-b430-33576aeeba07",
        "storage_key": "property/6767906449167168/01a140ab-aefa-772b-b430-33576aeeba07.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://whs.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10810173324901329160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasilla-high-school",
      "poi_latitude": "61.5883494",
      "poi_longitude": "-149.4311046",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-352-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPwlW2j_eyFYRCKklP11zBZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_919d616e-54bc-4d41-a8bc-800042cb41e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Wasilla Middle School",
      "poi_type": "Education",
      "poi_address": "650 E Bogard Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-4cab-737f-9807-fa96a0189745.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-4cab-737f-9807-fa96a0189745",
        "storage_key": "property/6767906449167168/019d021c-4cab-737f-9807-fa96a0189745.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://wms.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046694555322269747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasilla-middle-school",
      "poi_latitude": "61.5847536",
      "poi_longitude": "-149.432754",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-352-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR5Sa2BTeyFYRM8Dho_V1CUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b4b72bfd-8d84-4b4b-8fd5-fb567bf85f52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Knik Charter School",
      "poi_type": "Education",
      "poi_address": "758 N Shoreline Dr, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://knc.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11713259555538635479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knik-charter-school",
      "poi_latitude": "61.5866571",
      "poi_longitude": "-149.3396889",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-352-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJryLkVgDhyFYR14rUmYHbjaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_35ccaef6-898f-4df8-b04e-416900972f63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Knik Elementary School",
      "poi_type": "Education",
      "poi_address": "6350 W Hollywood Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-ab30-73bc-acd6-4088410b792b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-ab30-73bc-acd6-4088410b792b",
        "storage_key": "property/6767906449167168/01a140ab-ab30-73bc-acd6-4088410b792b.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://kne.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11485874634770813417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knik-elementary-school",
      "poi_latitude": "61.5404718",
      "poi_longitude": "-149.611237",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-352-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkXp1YpLcyFYR6REvJCAGZp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_63d6ae7a-df27-47b8-8305-d4ea81420d8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Tanaina Elementary School",
      "poi_type": "Education",
      "poi_address": "2550 Lucille St, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://tne.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9977787822350110754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanaina-elementary-school",
      "poi_latitude": "61.60821469999999",
      "poi_longitude": "-149.45407459999998",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-352-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXUJK3FfeyFYRIpBl6yg5eIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3a49bc16-9fc9-4716-b594-23d6d653cd6e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Wasilla Lake Christian School",
      "poi_type": "Education",
      "poi_address": "2001 E Palmer-Wasilla Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-ad57-7183-b85a-6f53ec9bf035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-ad57-7183-b85a-6f53ec9bf035",
        "storage_key": "property/6767906449167168/01a140ab-ad57-7183-b85a-6f53ec9bf035.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17099072749195610696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasilla-lake-christian-school",
      "poi_latitude": "61.58088600000001",
      "poi_longitude": "-149.399565",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-373-6439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl4alHiLeyFYRSMpdFBIcTO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_08441112-7d81-4ad2-a739-59834d8c9b62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Benteh early learning academy",
      "poi_type": "Education",
      "poi_address": "4401 E Palmer-Wasilla Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12268210735777305765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benteh-early-learning-academy",
      "poi_latitude": "61.585491700000006",
      "poi_longitude": "-149.339911",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnRVdQgDhyFYRpdSjF6pwQao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c4dd7d1f-a23d-4090-9e2b-4b4e4fe25ceb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Matanuska-Susitna College",
      "poi_type": "Education",
      "poi_address": "8295 College Dr, Palmer, AK 99645, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-b242-7662-9904-427effa293c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-b242-7662-9904-427effa293c8",
        "storage_key": "property/6767906449167168/01a140ab-b242-7662-9904-427effa293c8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://matsu.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6361200944555644070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matanuska-susitna-college",
      "poi_latitude": "61.57946799999999",
      "poi_longitude": "-149.240589",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-745-9774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZRZftKThyFYRplQeVY6GR1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_47a42771-8215-417b-a8e7-270d6f5543d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Valley Cinema",
      "poi_type": "Entertainment",
      "poi_address": "3331 E Old Matanuska Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "Multiplex offering Hollywood hits in plush, stadium-style seating, plus an arcade & eatery.",
      "poi_long_description": "Multiplex offering Hollywood hits in plush, stadium-style seating, plus an arcade & eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-55a5-7063-9c4a-a43cb3273fa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-55a5-7063-9c4a-a43cb3273fa8",
        "storage_key": "property/6767906449167168/019d021c-55a5-7063-9c4a-a43cb3273fa8.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://catheatres.com/the-valley-cinema/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14160263938289304344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-valley-cinema",
      "poi_latitude": "61.5661638",
      "poi_longitude": "-149.36655520000002",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 866-442-2463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a358-73f8-a64a-7d410a374b66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a358-73f8-a64a-7d410a374b66",
        "storage_key": "property/6767906449167168/019d021c-a358-73f8-a64a-7d410a374b66.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtYvpSKPgyFYRGAOCDwddg8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_581a3328-d36f-4b84-b902-4612194919ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Museum of Alaska Transportation",
      "poi_type": "Entertainment",
      "poi_address": "3800 W Museum Dr, Wasilla, AK 99654, USA",
      "poi_short_description": "Vintage trains, planes & automobiles are displayed at this museum devoted to old–school transport.",
      "poi_long_description": "Vintage trains, planes & automobiles are displayed at this museum devoted to old–school transport.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-2ea6-71fc-ac19-199e5b427e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-2ea6-71fc-ac19-199e5b427e23",
        "storage_key": "property/6767906449167168/01a140aa-2ea6-71fc-ac19-199e5b427e23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.museumofalaska.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1010469476589518268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-alaska-transportation",
      "poi_latitude": "61.57733289999999",
      "poi_longitude": "-149.54496709999998",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-376-1211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f05-73ae-81fa-2bb0d4438e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f05-73ae-81fa-2bb0d4438e7c",
        "storage_key": "property/6767906449167168/019d021c-9f05-73ae-81fa-2bb0d4438e7c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWEALiPcyFYRvD1-oKLoBQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_97788d19-9ba0-440d-9883-72dcbae23c40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Wasilla Museum & Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "391 Main St, Wasilla, AK 99654, USA",
      "poi_short_description": "Museum tracing the story of Wasilla, from its Native Athabaskan roots to the mining boom & beyond.",
      "poi_long_description": "Museum tracing the story of Wasilla, from its Native Athabaskan roots to the mining boom & beyond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-2d8a-7559-b53f-2d8bc72392bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-2d8a-7559-b53f-2d8bc72392bb",
        "storage_key": "property/6767906449167168/01a140aa-2d8a-7559-b53f-2d8bc72392bb.webp",
        "width": 1280,
        "height": 922
      },
      "poi_business_url": "http://www.cityofwasilla.gov/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=3630554720027945783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasilla-museum--visitor-center",
      "poi_latitude": "61.58292309999999",
      "poi_longitude": "-149.4408575",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-373-9071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f05-73ae-81fa-2bb0d4438e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f05-73ae-81fa-2bb0d4438e7c",
        "storage_key": "property/6767906449167168/019d021c-9f05-73ae-81fa-2bb0d4438e7c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJr--evWzeyFYRNyviSEhSYjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_15e6716a-3f3a-4c52-9775-db45577bdf81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Iditarod",
      "poi_type": "Shopping & Retail",
      "poi_address": "2100 S Knik Goose Bay Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "Museum in a log cabin with trophies, photos & videos of dog sledding, plus a gift shop & rides.",
      "poi_long_description": "Museum in a log cabin with trophies, photos & videos of dog sledding, plus a gift shop & rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-564d-7239-9a7c-fa8df9d47e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-564d-7239-9a7c-fa8df9d47e08",
        "storage_key": "property/6767906449167168/019d021c-564d-7239-9a7c-fa8df9d47e08.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://iditarod.com/plan-your-visit/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3871266369377050643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-iditarod",
      "poi_latitude": "61.560740300000006",
      "poi_longitude": "-149.4788451",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-376-5155 ext. 108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f05-73ae-81fa-2bb0d4438e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f05-73ae-81fa-2bb0d4438e7c",
        "storage_key": "property/6767906449167168/019d021c-9f05-73ae-81fa-2bb0d4438e7c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVVW4yFYRE6CiiUCAuTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_548846d7-c765-48a2-ac1a-b99694b2465c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Bearpaw River Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "240 E Railroad Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "Casual brewery and pizza restaurant serving craft beers and wood-fired pizzas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-268f-730e-90e0-78b17795ea62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-268f-730e-90e0-78b17795ea62",
        "storage_key": "property/6767906449167168/01a140aa-268f-730e-90e0-78b17795ea62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bearpawriverbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3985454473804711225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bearpaw-river-brewing-company",
      "poi_latitude": "61.5795158",
      "poi_longitude": "-149.4456078",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-373-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-990a-70b6-b395-10d9a117c8b2",
        "storage_key": "property/6767906449167168/019d021c-990a-70b6-b395-10d9a117c8b2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW2JUhCHfyFYROQWfY7otTzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_fe797e87-b1c8-4f45-8b23-3c179dcc1e9b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Curtis D. Menard Memorial Sports Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1001 S Clapp St, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-b2f9-764d-8383-50fd333be476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-b2f9-764d-8383-50fd333be476",
        "storage_key": "property/6767906449167168/01a140ab-b2f9-764d-8383-50fd333be476.webp",
        "width": 1280,
        "height": 797
      },
      "poi_business_url": "http://www.cityofwasilla.com/menard",
      "poi_directions_map_url": "https://maps.google.com/?cid=11222178764272363446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "curtis-d-menard-memorial-sports-center",
      "poi_latitude": "61.5720886",
      "poi_longitude": "-149.5170681",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-357-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTkyyC3cyFYRtudi4iAwvZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_cf9b6455-7415-4f8f-bc4a-877d77e8d341",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Newcomb Park Wasilla Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "891 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Family-friendly lakeside park featuring a playground and water access for swimming and kayaking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-441f-747d-9150-6f24b7cc5747.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-441f-747d-9150-6f24b7cc5747",
        "storage_key": "property/6767906449167168/01a140aa-441f-747d-9150-6f24b7cc5747.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5584510842929009319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newcomb-park-wasilla-lake",
      "poi_latitude": "61.5806662",
      "poi_longitude": "-149.4262664",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-373-9030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a396-7038-ad2b-bedfa209e606",
        "storage_key": "property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6pq9hPeyFYRp9IZDQYrgE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e5d4a064-7695-4dea-ac6b-26ef605859e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Iditapark",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "594 W Nelson Ave #220, Wasilla, AK 99654, USA",
      "poi_short_description": "Spacious community park featuring an extensive children's playground and walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-5e2b-77ed-a819-15b12fd87915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-5e2b-77ed-a819-15b12fd87915",
        "storage_key": "property/6767906449167168/019d021c-5e2b-77ed-a819-15b12fd87915.webp",
        "width": 828,
        "height": 460
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17621938527586979509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iditapark",
      "poi_latitude": "61.5844031",
      "poi_longitude": "-149.4625347",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-373-9010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a396-7038-ad2b-bedfa209e606",
        "storage_key": "property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZC7YGXeyFYRtY6XzrmzjfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3b14d68c-29d9-46cf-a553-9ff022ff9006",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Lake Lucile Park Campground",
      "poi_type": "Entertainment",
      "poi_address": "1401 S Endeavor St, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-b9a6-7472-acf7-994ef7353f3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-b9a6-7472-acf7-994ef7353f3f",
        "storage_key": "property/6767906449167168/01a140ab-b9a6-7472-acf7-994ef7353f3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofwasilla.gov/services/departments/parks-and-recreation/city-parks/lake-lucile-park/camping-rv-parking",
      "poi_directions_map_url": "https://maps.google.com/?cid=15459094205657077104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-lucile-park-campground",
      "poi_latitude": "61.5687147",
      "poi_longitude": "-149.4748205",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-db45-732b-b3ed-46c0a852d5ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ab-db45-732b-b3ed-46c0a852d5ea",
        "storage_key": "property/6767906449167168/01a140ab-db45-732b-b3ed-46c0a852d5ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSyxrjdjdyFYRcFV9NUa8idY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_4d7a0879-98ac-420f-93a1-dba5777981dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Wasilla Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "1105 E Depot Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-b5ac-7614-a71d-15920f96fb13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-b5ac-7614-a71d-15920f96fb13",
        "storage_key": "property/6767906449167168/01a140ab-b5ac-7614-a71d-15920f96fb13.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7689853922488183214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasilla-depot",
      "poi_latitude": "61.57865760000001",
      "poi_longitude": "-149.421655",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65nyaBnfyFYRrmmNYGbZt2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_4cd3770b-c8a9-4cd1-848f-439d01415a76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Mat-Su Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 S Woodworth Loop, Palmer, AK 99645, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-639b-70aa-bb1b-05131e4c7949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-639b-70aa-bb1b-05131e4c7949",
        "storage_key": "property/6767906449167168/019d021c-639b-70aa-bb1b-05131e4c7949.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.matsuregional.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=326787996786308655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mat-su-regional-medical-center",
      "poi_latitude": "61.5631321",
      "poi_longitude": "-149.25771369999998",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-861-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a30d-71df-95eb-6c579336b444.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a30d-71df-95eb-6c579336b444",
        "storage_key": "property/6767906449167168/019d021c-a30d-71df-95eb-6c579336b444.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJYfJWQAzhyFYRLzZPofP7iAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_cf889e1a-7665-460a-b556-891d3a69ba2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Mat-Su Regional Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "950 E Bogard Rd #103, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-b735-718f-8dd0-f1449b6dce64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-b735-718f-8dd0-f1449b6dce64",
        "storage_key": "property/6767906449167168/01a140ab-b735-718f-8dd0-f1449b6dce64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mat-su-chs.inquicker.com/providers/23403?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9896474652559292264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mat-su-regional-urgent-care",
      "poi_latitude": "61.58629440000001",
      "poi_longitude": "-149.4263819",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-352-2880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8eEffhXeyFYRaDd0QkNXV4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f0590303-453b-4fa1-9522-aae3a473f97a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1721 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-4666-710e-b8bf-1acd93840f12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-4666-710e-b8bf-1acd93840f12",
        "storage_key": "property/6767906449167168/019d021c-4666-710e-b8bf-1acd93840f12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1721+e+parks+hwy-wasilla-ak-99654/id=12681",
      "poi_directions_map_url": "https://maps.google.com/?cid=8904050703836275532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.577340500000005",
      "poi_longitude": "-149.4070095",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-631-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU4TCw3_eyFYRTGM6gPCKkXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ca8f514e-eded-4bcb-b688-477c61320e1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-bc4d-7323-b231-087eb8634789.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-bc4d-7323-b231-087eb8634789",
        "storage_key": "property/6767906449167168/01a140ab-bc4d-7323-b231-087eb8634789.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00653?cid=loc_70100653P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12774986835829781165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "61.579397099999994",
      "poi_longitude": "-149.4090072",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-352-5033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a398-775a-b50f-d7549c685a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a398-775a-b50f-d7549c685a62",
        "storage_key": "property/6767906449167168/019d021c-a398-775a-b50f-d7549c685a62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wJyCxneyFYRrfLsp9feSbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4cf9bc18-1a9d-499e-a651-33fb67d8d1da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "The Alaska Club Wasilla Gym & Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "1720 E Parks Hwy, Wasilla, AK 99654, USA",
      "poi_short_description": "Full-service fitness center featuring a swimming pool and comprehensive strength and cardio equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-3767-737e-ba40-954c265eb150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-3767-737e-ba40-954c265eb150",
        "storage_key": "property/6767906449167168/01a140aa-3767-737e-ba40-954c265eb150.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacwasilla-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=9513456186662735781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-wasilla-gym--pool",
      "poi_latitude": "61.57431419999999",
      "poi_longitude": "-149.4080519",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-376-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz-8u9hveyFYRpU9GUP-VBoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0dee7d3d-6985-41e7-9fc6-bb4a645cb599",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2241 Sun Mountain Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "Welcoming gym offering a wide variety of fitness equipment and premium amenities like hydro beds and tanning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-6adf-72c0-9dca-2175e9e18a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-6adf-72c0-9dca-2175e9e18a8c",
        "storage_key": "property/6767906449167168/019d021c-6adf-72c0-9dca-2175e9e18a8c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wasilla-ak?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4764902275588990302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "61.574677599999994",
      "poi_longitude": "-149.39349339999998",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-376-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMX3cJxHfyFYRXqXuxV9VIEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d4bda368-e998-411b-92d2-2d29ab3da7d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Innergy Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "617 S Knik Goose Bay Rd Ste E, Wasilla, AK 99654, USA",
      "poi_short_description": "Welcoming fitness studio offering yoga, barre, and cycling classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-cde4-743c-8cff-87996b54b311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-cde4-743c-8cff-87996b54b311",
        "storage_key": "property/6767906449167168/01a140ab-cde4-743c-8cff-87996b54b311.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.innergyalaska.com/getstarted",
      "poi_directions_map_url": "https://maps.google.com/?cid=14138883165773693909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "innergy-fitness-studio",
      "poi_latitude": "61.57609499999999",
      "poi_longitude": "-149.43881299999998",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-841-2120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs1uTZBnfyFYR1QOxCFRnN8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_af8008ad-96b4-40e7-b91c-34c4c96354da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Studio 3 Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "701 S Knik Goose Bay Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-baca-75b0-bb55-28dcd1495d80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-baca-75b0-bb55-28dcd1495d80",
        "storage_key": "property/6767906449167168/01a140ab-baca-75b0-bb55-28dcd1495d80.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.innergyalaska.com/studio3pilates",
      "poi_directions_map_url": "https://maps.google.com/?cid=3398116624803893122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-3-pilates",
      "poi_latitude": "61.576493799999994",
      "poi_longitude": "-149.44033149999998",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-841-2120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqTjYnmzfyFYRgg_J9hCJKC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_060ff16f-87b5-4a1c-9436-22af31b37db9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Yoga OM Alaska",
      "poi_type": "Health and Wellness",
      "poi_address": "960 S Check St, Wasilla, AK 99654, USA",
      "poi_short_description": "Friendly instructors and a welcoming vibe define this studio offering yoga classes for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-be3e-7240-8138-4a247b4237f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-be3e-7240-8138-4a247b4237f5",
        "storage_key": "property/6767906449167168/01a140ab-be3e-7240-8138-4a247b4237f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yogaomalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4837133987549392342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-om-alaska",
      "poi_latitude": "61.5732447",
      "poi_longitude": "-149.4453059",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 213-855-3142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-hKi1XfyFYR1q3ZwrvzIEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_06f89530-f6f9-43cc-bef8-dc993c1bf790",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Carter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 S Lake St, Wasilla, AK 99654, USA",
      "poi_short_description": "Quiet lakeside park featuring a playground and duck feeding.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-bf18-72ca-a451-06bb10dda41f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-bf18-72ca-a451-06bb10dda41f",
        "storage_key": "property/6767906449167168/01a140ab-bf18-72ca-a451-06bb10dda41f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cityofwasilla.gov/services/departments/parks-and-recreation/city-parks/carter-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14146433222412251994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carter-park",
      "poi_latitude": "61.5775337",
      "poi_longitude": "-149.4493504",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-373-9010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a396-7038-ad2b-bedfa209e606",
        "storage_key": "property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8x7l7XLeyFYRWrOqlBA6UsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eae6c2f7-e99a-4a74-8eed-408f666c5f64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Nunley Park Wasilla Parks & Recreation",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "250 E Swanson Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "Public park featuring a playground, swings, slides, and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-c16f-706f-853c-8acf22385e38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-c16f-706f-853c-8acf22385e38",
        "storage_key": "property/6767906449167168/01a140ab-c16f-706f-853c-8acf22385e38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofwasilla.gov/services/departments/parks-and-recreation/city-parks/nunley-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11056179486023826208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nunley-park-wasilla-parks--recreation",
      "poi_latitude": "61.5818519",
      "poi_longitude": "-149.4442994",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-373-9010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a396-7038-ad2b-bedfa209e606",
        "storage_key": "property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg04Y-mzeyFYRIDtpFapwb5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f6ee7cbc-c8b8-491f-a0b4-fc79c124dd50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Pedersen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-c366-7278-98fd-3682ef454303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-c366-7278-98fd-3682ef454303",
        "storage_key": "property/6767906449167168/01a140ab-c366-7278-98fd-3682ef454303.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofwasilla.gov/services/departments/parks-and-recreation/city-parks/pedersen-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16302253853696668669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pedersen-park",
      "poi_latitude": "61.57399629999999",
      "poi_longitude": "-149.4108882",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a396-7038-ad2b-bedfa209e606",
        "storage_key": "property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUpWjv3fyFYR_TPVw4E9PeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0e1f8f67-b2df-455e-9b82-94d837388a23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Alcantra Disc Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-c305-7420-846f-4090e5d343aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-c305-7420-846f-4090e5d343aa",
        "storage_key": "property/6767906449167168/01a140ab-c305-7420-846f-4090e5d343aa.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12016039023759237236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alcantra-disc-golf-course",
      "poi_latitude": "61.6125892",
      "poi_longitude": "-149.3878617",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0krMM_fyFYRdKBmEtSLwaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_a97e0dca-4c6a-4162-bb3c-ee2de9d84887",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Wasilla Creek Boardwalk Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5990 E Nelson Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "Trail through the woods and marsh ending at a nice platform that overlooks mountains.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-c549-72f8-834b-382dabb90f24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-c549-72f8-834b-382dabb90f24",
        "storage_key": "property/6767906449167168/01a140ab-c549-72f8-834b-382dabb90f24.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5442764150669987189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasilla-creek-boardwalk-trail",
      "poi_latitude": "61.5504629",
      "poi_longitude": "-149.2958539",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-db28-775c-b3a0-008676d77fc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ab-db28-775c-b3a0-008676d77fc8",
        "storage_key": "property/6767906449167168/01a140ab-db28-775c-b3a0-008676d77fc8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJkWNVIibhyFYRdU3qdCiViEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_615c52a6-dfa4-4c48-9ed3-1217fa2a3371",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Bumpus Ballpark",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2001 Mystery Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140aa-44f6-75be-bfff-6fa3188bf782.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140aa-44f6-75be-bfff-6fa3188bf782",
        "storage_key": "property/6767906449167168/01a140aa-44f6-75be-bfff-6fa3188bf782.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://m.facebook.com/profile.php?id=147769898585251&__tn__=C-R",
      "poi_directions_map_url": "https://maps.google.com/?cid=15619676335121725891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bumpus-ballpark",
      "poi_latitude": "61.592882800000005",
      "poi_longitude": "-149.4982825",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a396-7038-ad2b-bedfa209e606",
        "storage_key": "property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc40WmY_eyFYRw3mBxd48xNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c588fa2c-2059-4495-8914-10e0c57834f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Finger Lake State Recreation Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7287 E Bogard Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-c5a8-708c-8d08-090acbf4d719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-c5a8-708c-8d08-090acbf4d719",
        "storage_key": "property/6767906449167168/01a140ab-c5a8-708c-8d08-090acbf4d719.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://dnr.alaska.gov/parks/aspunits/matsu/fingerlksrs.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12350463937899039974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "finger-lake-state-recreation-site",
      "poi_latitude": "61.611291400000006",
      "poi_longitude": "-149.2657954",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-745-8950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-db45-732b-b3ed-46c0a852d5ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ab-db45-732b-b3ed-46c0a852d5ea",
        "storage_key": "property/6767906449167168/01a140ab-db45-732b-b3ed-46c0a852d5ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj9-3mDrgyFYR5oy-FYSpZas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_6ce13ec0-bc44-4d31-9d0f-8938b27cb789",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Saint John-Wasilla Airpark",
      "poi_type": "Transportation & Transit",
      "poi_address": "Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10842940371978981309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-john-wasilla-airpark",
      "poi_latitude": "61.55798879999999",
      "poi_longitude": "-149.4240777",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a7aa-75df-a493-5bba1f2a88c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a7aa-75df-a493-5bba1f2a88c0",
        "storage_key": "property/6767906449167168/019d021c-a7aa-75df-a493-5bba1f2a88c0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQ80sv_dyFYRvY-M6NHceZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_cedb407c-b250-4e29-af1f-a02c519d2ab3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Valley Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "225 W Riley Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-c873-749b-a97f-16bd326045d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-c873-749b-a97f-16bd326045d9",
        "storage_key": "property/6767906449167168/01a140ab-c873-749b-a97f-16bd326045d9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.valleytransitak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=419924562429028061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-transit",
      "poi_latitude": "61.57186969999999",
      "poi_longitude": "-149.4566017",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-864-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0c-7448-a517-bc7f496e4db5",
        "storage_key": "property/6767906449167168/019d021c-9f0c-7448-a517-bc7f496e4db5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ0Jjv3TeyFYR3SYLKCrf0wU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_98fde92c-af15-4df7-8eaf-dbf7a2edc1c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Trunk Road Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 E Blue Lupine Dr, Palmer, AK 99645, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-cc60-77bd-846d-e63cfb3c85b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-cc60-77bd-846d-e63cfb3c85b2",
        "storage_key": "property/6767906449167168/01a140ab-cc60-77bd-846d-e63cfb3c85b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10229930067188682636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trunk-road-park--ride",
      "poi_latitude": "61.56567149999999",
      "poi_longitude": "-149.26374819999998",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-db28-775c-b3a0-0583bd34cca7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ab-db28-775c-b3a0-0583bd34cca7",
        "storage_key": "property/6767906449167168/01a140ab-db28-775c-b3a0-0583bd34cca7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAA0w7hyFYRjI_eEzID-I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_ad796d08-cb07-40a8-ab0b-31be504b7678",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Seward Meridian Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "E Blue Lupine Dr, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-cb32-757d-a859-1dd02614ea5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-cb32-757d-a859-1dd02614ea5b",
        "storage_key": "property/6767906449167168/01a140ab-cb32-757d-a859-1dd02614ea5b.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17449031947016493390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seward-meridian-park--ride",
      "poi_latitude": "61.5723169",
      "poi_longitude": "-149.3586604",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-db28-775c-b3a0-0583bd34cca7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ab-db28-775c-b3a0-0583bd34cca7",
        "storage_key": "property/6767906449167168/01a140ab-db28-775c-b3a0-0583bd34cca7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVUVcJbgyFYRTllcXBtqJ_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_1bf44d14-8162-40ac-873b-94fc651c92aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Big Lake South State Recreation Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4678 S Big Lake Rd, Wasilla, AK 99654, USA",
      "poi_short_description": "State park with a public restroom, picnic tables, and a boat launch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-cea5-71e5-9188-591811b05585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-cea5-71e5-9188-591811b05585",
        "storage_key": "property/6767906449167168/01a140ab-cea5-71e5-9188-591811b05585.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dnr.alaska.gov/parks/aspunits/matsu/biglakesosrs.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=9534717252933120762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-lake-south-state-recreation-site",
      "poi_latitude": "61.5324494",
      "poi_longitude": "-149.8320714",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 27 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 907-269-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a396-7038-ad2b-bedfa209e606",
        "storage_key": "property/6767906449167168/019d021c-a396-7038-ad2b-bedfa209e606.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ_UJD0DFyFYR-vLdDtMeUoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_bdfa935f-4511-455b-9cf8-1266d6846a8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-cd1f-7193-b58a-2008f3c31a51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-cd1f-7193-b58a-2008f3c31a51",
        "storage_key": "property/6767906449167168/01a140ab-cd1f-7193-b58a-2008f3c31a51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "47.8",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "59 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a7aa-75df-a493-5bba1f2a88c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a7aa-75df-a493-5bba1f2a88c0",
        "storage_key": "property/6767906449167168/019d021c-a7aa-75df-a493-5bba1f2a88c0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_490eaf27-6775-4c90-b3c1-a5b6177b841d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Matanuska Susitna Administration Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "350 E Dahlia Ave, Palmer, AK 99645, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://matsu.gov/departments",
      "poi_directions_map_url": "https://maps.google.com/?cid=818152378316726713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matanuska-susitna-administration-office",
      "poi_latitude": "61.59971019999999",
      "poi_longitude": "-149.1083272",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-861-7801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a86a-729d-b355-e3e659154a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a86a-729d-b355-e3e659154a4a",
        "storage_key": "property/6767906449167168/019d021c-a86a-729d-b355-e3e659154a4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiaSQyO8dyVYRuaG12UCpWgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_62d8f2d0-afca-4ca8-b301-1501fe5c82ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Mat-Su Borough School District",
      "poi_type": "Education",
      "poi_address": "501 N Gulkana St, Palmer, AK 99645, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-d1c6-744a-9f4c-e4c4476311c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-d1c6-744a-9f4c-e4c4476311c4",
        "storage_key": "property/6767906449167168/01a140ab-d1c6-744a-9f4c-e4c4476311c4.webp",
        "width": 975,
        "height": 1280
      },
      "poi_business_url": "https://www.matsuk12.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6094409439866873960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mat-su-borough-school-district",
      "poi_latitude": "61.611259999999994",
      "poi_longitude": "-149.097355",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 907-746-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-9f0b-750c-9419-c7d413a68be7",
        "storage_key": "property/6767906449167168/019d021c-9f0b-750c-9419-c7d413a68be7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHdii38IdyVYRaGgNkxixk1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_985574fa-87f9-4bf1-85c1-78d0e15bfe29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Mat-Su Pre-Trial Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "339 E Dogwood Ave, Palmer, AK 99645, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-d28c-714d-81cd-400fc09dfc5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-d28c-714d-81cd-400fc09dfc5d",
        "storage_key": "property/6767906449167168/01a140ab-d28c-714d-81cd-400fc09dfc5d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://doc.alaska.gov/institutions/mat-su",
      "poi_directions_map_url": "https://maps.google.com/?cid=7395253272699142690&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mat-su-pre-trial-facility",
      "poi_latitude": "61.602313800000005",
      "poi_longitude": "-149.10948589999998",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-745-0943",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a86a-729d-b355-e3e659154a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a86a-729d-b355-e3e659154a4a",
        "storage_key": "property/6767906449167168/019d021c-a86a-729d-b355-e3e659154a4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxK5du8dyVYRIgJHd6s3oWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_2bef0474-4a72-4e6f-a7f0-8b2d53af7a2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "Alaska State Troopers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "453 S Valley Way, Palmer, AK 99645, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dps.alaska.gov/AST/BDetachment/Home",
      "poi_directions_map_url": "https://maps.google.com/?cid=16095811793759679048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-state-troopers",
      "poi_latitude": "61.601931099999995",
      "poi_longitude": "-149.1109333",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-745-2131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-db4c-7728-aef5-06a050b55aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ab-db4c-7728-aef5-06a050b55aeb",
        "storage_key": "property/6767906449167168/01a140ab-db4c-7728-aef5-06a050b55aeb.webp",
        "width": 177,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1KUfOUdyVYRSLKWEozPX98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "police"
    },
    {
      "id": "custom_3664e7c1-b190-4984-989a-13025b5f63a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "poi_name": "City of Wasilla",
      "poi_type": "Major Employers & Offices",
      "poi_address": "290 E Herning Ave, Wasilla, AK 99654, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a140ab-d36c-72e7-966c-67ddaf8ef6ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-d36c-72e7-966c-67ddaf8ef6ea",
        "storage_key": "property/6767906449167168/01a140ab-d36c-72e7-966c-67ddaf8ef6ea.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofwasilla.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6772368982150495374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-wasilla",
      "poi_latitude": "61.582156899999994",
      "poi_longitude": "-149.44428539999998",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-373-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021c-a86a-729d-b355-e3e659154a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-a86a-729d-b355-e3e659154a4a",
        "storage_key": "property/6767906449167168/019d021c-a86a-729d-b355-e3e659154a4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVUF_GzeyFYRjjz0LLVJ_F0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5ba88f2557e2f9a4bd5bf5b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_953e7f61a1aa25c1fe9b21c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9de24d711e2c7f92946d470a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_367f34415a009067a61029ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_84a49dc55c4d0f9e62abab7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_79d7ea2f-8ff5-45df-bcac-284f9f52034f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "rating": "5.0",
      "name": "Devina Elizabeth",
      "text": "I just picked up my keys from Alaska who has been incredibly helpful and communicative since I called last week praying that they had an apartment unit available that fit our small family in short notice. His help has been incredible and has kept us level headed during this stressful time! The unit is clean and Alaska helped us get into a unit that was immediately available with more square footage for a lower price. He is definitely the reason that this place feels like home on day one!",
      "date": "2025-09-25",
      "title": ""
    },
    {
      "id": "custom_1c4ea01c-30e8-496c-ab57-96a9f566c2ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "rating": "5.0",
      "name": "Cameron Lugo",
      "text": "Amazing experience, Alaska made it very smooth and easy for me to find a place and move in as fast as I needed. I 100% recommend this business for any apartment needs. They are very responsive and always on top of maintenance that needs done, trash removal when the dumpster fills, and snow removal so you can get in and out. If you need a reliable and responsive, outgoing team. Join us at amber ridge",
      "date": "2025-07-18",
      "title": ""
    },
    {
      "id": "custom_a3352e01-2770-4a15-9170-1d93bfd4824c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "rating": "5.0",
      "name": "Alexandra M",
      "text": "Sherry the manager of Amber Ridge Apartments has been great. Whenever there is an issue she is prompt in addressing it. I have dealt with many apartment managers before and Sherry is one of the best and most caring about her tenants that I have encountered. It is out of her hands if tenants don't comply (ie. cleaning dog poop), but she tries to keep the complex as clean as possible. Also I have recently had my dishwasher replaced. Jeremiah ,the maintenance worker, was  nice and professional. Thanks for all you guys do!",
      "date": "2024-06-18",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_05767063-c2c1-4211-9b6f-663a57cd298b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019ddcf7-d7b1-73a0-81e5-ea3c35c67252.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-d7b1-73a0-81e5-ea3c35c67252",
        "storage_key": "property/6767906449167168/019ddcf7-d7b1-73a0-81e5-ea3c35c67252.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 590SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HZDvtx19e98"
    },
    {
      "id": "custom_94edbbcc-6ef2-4676-8010-73bdcb897459",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a1791f-9cce-7559-bcb8-20043d28b4a4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1791f-9cce-7559-bcb8-20043d28b4a4",
        "storage_key": "property/6767906449167168/01a1791f-9cce-7559-bcb8-20043d28b4a4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Amber Ridge | Laundry Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tqidJ9GMR1x"
    },
    {
      "id": "custom_0e2af6a2-1969-4555-a17c-5005ed024669",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a17920-89d6-707c-b6c4-def5549fdf9b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17920-89d6-707c-b6c4-def5549fdf9b",
        "storage_key": "property/6767906449167168/01a17920-89d6-707c-b6c4-def5549fdf9b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 537SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=B6guQpu7rHo"
    },
    {
      "id": "custom_81457574-91ef-4ff2-bb3a-d5a2b8c1e4f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/01a17922-78db-702d-aa94-90b41e9d447c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17922-78db-702d-aa94-90b41e9d447c",
        "storage_key": "property/6767906449167168/01a17922-78db-702d-aa94-90b41e9d447c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA + Office - 780SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=uhe44WWVqjg"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d0d2-7265-a627-5d8e2c1d79d0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Amber Ridge Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-wasilla-ak",
      "search_query": "apartments with dishwashers Wasilla AK",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Wasilla, AK",
      "h2_subtitle": "Looking for apartments with dishwashers in Wasilla, AK? Discover the convenience of Amber Ridge Apartments' amenities.",
      "page_copy": "Discover your ideal home at Amber Ridge Apartments, where convenience meets comfort. Our apartments with dishwashers in Wasilla, AK, are designed to make everyday living a breeze. Enjoy preparing meals in a well-appointed kitchen equipped with a dishwasher and Energy Star Certified appliances, ensuring both efficiency and eco-friendliness.\n\nLocated in the serene Matanuska-Susitna Borough, Amber Ridge Apartments offers smoke-free living with open grounds, perfect for those who appreciate fresh air and outdoor spaces. Each unit is thoughtfully designed to make life easier, allowing you to focus on what matters most. Experience the best of apartment living with us.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dishwashers in Wasilla, AK | Amber Ridge",
      "seo_description": "Explore Amber Ridge Apartments in Wasilla, AK with dishwashers & more amenities. Enjoy eco-friendly living and a smoke-free environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-wasilla",
      "search_query": "energy efficient apartments Wasilla",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in Wasilla",
      "h2_subtitle": "Looking for energy efficient apartments in Wasilla? Amber Ridge Apartments offers eco-friendly living with modern amenities.",
      "page_copy": "Amber Ridge Apartments is the perfect choice for those seeking energy efficient apartments in the heart of Wasilla. Our homes are designed with Energy Star Certified appliances, ensuring that you enjoy both comfort and sustainability. These features not only help reduce your carbon footprint but also lower energy costs, making living here a smart and economical choice.\n\nSet within the beautiful Matanuska-Susitna Borough, Amber Ridge boasts smoke-free living and open grounds, which enhance the serene surroundings. The inclusion of modern conveniences like dishwashers and microwaves* further amplifies the ease of living here. Experience a blend of efficiency and comfort at Amber Ridge Apartments, where your eco-friendly lifestyle starts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apartments Wasilla | Amber Ridge",
      "seo_description": "Discover energy efficient living at Amber Ridge Apartments in Wasilla. Enjoy eco-friendly amenities and modern comforts in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "granite-countertops-apartment-matanuska-susitna-borough",
      "search_query": "granite countertops apartment Matanuska-Susitna Borough",
      "category": "Amenity",
      "h1_title": "Granite Countertops Apartments in Matanuska-Susitna",
      "h2_subtitle": "Explore granite countertops apartment options in Matanuska-Susitna Borough at Amber Ridge Apartments.",
      "page_copy": "Find your perfect home with Amber Ridge Apartments, the ideal destination for those seeking a granite countertops apartment in Matanuska-Susitna Borough. While our kitchens boast modern Energy Star Certified appliances like dishwashers and microwaves*, the allure of granite countertops adds a touch of elegance to your culinary space.\n\nLocated in the peaceful locale of Wasilla, Amber Ridge Apartments offers more than just style. Enjoy smoke-free living and open grounds that invite relaxation and outdoor activities. In a home optimized for both aesthetic appeal and functionality, Amber Ridge provides a unique living experience that combines luxury with eco-friendly living, perfect for today's discerning renter.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops Apts Matanuska-Susitna | Amber Ridge",
      "seo_description": "Discover stylish apartments with granite countertops and modern amenities at Amber Ridge in Matanuska-Susitna Borough. Luxury meets eco-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "walk-in-closet-apartments-near-wasilla",
      "search_query": "walk-in closet apartments near Wasilla",
      "category": "Amenity",
      "h1_title": "Walk-In Closet Apartments Near Wasilla",
      "h2_subtitle": "Discover walk-in closet apartments near Wasilla at Amber Ridge. Enjoy spacious living and modern amenities designed for comfort and convenience.",
      "page_copy": "Amber Ridge Apartments is your destination for spacious living near Wasilla, where walk-in closet apartments offer the ideal solution for those needing extra storage and organization. Our floor plans are designed to maximize your living space, providing ample room for your wardrobe and more.\n\nSituated in the tranquility of the Matanuska-Susitna Borough, Amber Ridge provides not only the luxury of large closet spaces but also modern amenities like Energy Star Certified appliances, including dishwashers and microwaves*. With smoke-free living and open grounds enhancing your experience, Amber Ridge combines functionality with style just minutes from Wasilla.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closet Apts Near Wasilla | Amber Ridge",
      "seo_description": "Explore spacious walk-in closet apartments near Wasilla at Amber Ridge. Enjoy ample storage with modern amenities in a tranquil setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "views-apartments-open-grounds-ak",
      "search_query": "views apartments with open grounds AK",
      "category": "Amenity",
      "h1_title": "Views Apartments with Open Grounds in AK",
      "h2_subtitle": "Experience scenic views apartments with open grounds in AK at Amber Ridge Apartments. Find serenity and comfort all in one place.",
      "page_copy": "Amber Ridge Apartments in AK offers stunning views apartments with open grounds, ensuring your environment is both visually captivating and spacious. Nestled in the serene Matanuska-Susitna Borough, our apartments provide picturesque vistas that bring the beauty of Alaska right to your doorstep.\n\nOpen grounds at Amber Ridge create an environment that encourages outdoor enjoyment and leisure. Our property also features modern amenities such as Energy Star Certified appliances, dishwashers, and microwaves*, all within a smoke-free setting. Enjoy a lifestyle that combines breathtaking natural beauty with the peace of mind that comes from eco-friendly living and contemporary conveniences at Amber Ridge Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Views Apartments with Open Grounds AK | Amber Ridge",
      "seo_description": "Discover views apartments with open grounds in AK at Amber Ridge. Experience tranquil living with stunning vistas and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-wasilla-ak",
      "search_query": "one bedroom apartments wasilla ak",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Wasilla, AK",
      "h2_subtitle": "Find ideal one bedroom apartments in Wasilla, AK at Amber Ridge. Enjoy modern amenities and a welcoming community atmosphere.",
      "page_copy": "Discover the comfort and convenience of one bedroom apartments in Wasilla, AK, at Amber Ridge Apartments. Our thoughtfully designed units provide the perfect blend of cozy living and practical features, like Energy Star Certified appliances that include dishwashers and microwaves* for efficient kitchen use.\n\nLocated in the heart of Matanuska-Susitna Borough, Amber Ridge offers a welcoming environment with open grounds and a smoke-free policy to enhance your living experience. Enjoy all the benefits of living in a tight-knit community while being surrounded by the natural beauty of Wasilla. Experience comfort and style at Amber Ridge Apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Wasilla, AK | Amber Ridge",
      "seo_description": "Explore one bedroom apartments in Wasilla, AK at Amber Ridge. Enjoy modern designs and amenities in a welcoming, scenic setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-matanuska-susitna-borough",
      "search_query": "two bedroom apartments in matanuska-susitna borough",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Matanuska-Susitna",
      "h2_subtitle": "Explore two bedroom apartments in Matanuska-Susitna Borough at Amber Ridge. Comfort and modern amenities await you.",
      "page_copy": "Amber Ridge Apartments offers spacious two bedroom apartments in the heart of Matanuska-Susitna Borough. These well-designed units provide ample space for families or roommates looking to enjoy both privacy and shared living areas. Our homes come equipped with modern conveniences, including Energy Star Certified appliances such as dishwashers and microwaves* to make everyday living more efficient.\n\nSet in a serene environment with open grounds, Amber Ridge ensures a tranquil lifestyle with no smoking allowed on-site. The apartments are designed for those seeking comfort, with access to all the natural beauty and recreational opportunities the borough has to offer. Experience the best of Alaskan living with us.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Matanuska-Susitna | Amber Ridge",
      "seo_description": "Find spacious two bedroom apartments in Matanuska-Susitna Borough at Amber Ridge. Enjoy modern living in a serene, smoke-free setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "apartments-near-iditapark-wasilla",
      "search_query": "apartments near Iditapark Wasilla",
      "category": "Park",
      "h1_title": "Apartments Near Iditapark Wasilla",
      "h2_subtitle": "Discover apartments near Iditapark in Wasilla at Amber Ridge. Enjoy proximity to nature and modern amenities.",
      "page_copy": "Located conveniently near Iditapark, Amber Ridge Apartments in Wasilla offers an ideal home for nature lovers and city dwellers alike. These apartments provide the perfect balance of accessibility and tranquility, allowing residents quick access to outdoor activities and the vibrant community life.\n\nAmber Ridge features a variety of modern amenities, including Energy Star Certified appliances, dishwashers, and microwaves*. Our open grounds are perfect for enjoying fresh Alaskan air, and as a smoke-free community, we prioritize health and well-being. Experience the best of both worlds with a home that’s close to Iditapark and filled with contemporary conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Iditapark Wasilla | Amber Ridge",
      "seo_description": "Find apartments near Iditapark in Wasilla at Amber Ridge. Enjoy a unique blend of nature access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "wasilla-lake-newcomb-park-nearby-apartments",
      "search_query": "Wasilla Lake Newcomb Park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Wasilla Lake & Newcomb Park",
      "h2_subtitle": "Find nearby apartments to Wasilla Lake and Newcomb Park at Amber Ridge. Enjoy lakeside living with modern comforts.",
      "page_copy": "Experience the beauty of lakeside living with apartments located near Wasilla Lake and Newcomb Park at Amber Ridge Apartments. Our community offers a perfect home base for those who love the outdoors, providing easy access to the scenic views and recreational activities of these local landmarks.\n\nAmber Ridge Apartments combines this prime location with modern living features, including smoke-free open grounds and Energy Star Certified appliances like dishwashers and microwaves* in each unit. Whether you're enjoying a stroll by the lake or relaxing at home, Amber Ridge offers an unmatched living experience in Wasilla.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wasilla Lake & Newcomb Park",
      "seo_description": "Discover nearby apartments to Wasilla Lake and Newcomb Park at Amber Ridge. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "apartments-close-to-bumpus-ballpark-wasilla-ak",
      "search_query": "apartments close to Bumpus Ballpark Wasilla AK",
      "category": "Park",
      "h1_title": "Apartments Close to Bumpus Ballpark",
      "h2_subtitle": "Explore our apartments close to Bumpus Ballpark in Wasilla, AK. Experience vibrant living with modern conveniences.",
      "page_copy": "Amber Ridge Apartments offers an unbeatable location close to Bumpus Ballpark in Wasilla, AK. Perfect for sports enthusiasts and families, our community provides easy access to the sporting activities and events at this local hotspot.\n\nOur apartments blend convenience with comfort, highlighting features like smoke-free open grounds and Energy Star Certified appliances that include dishwashers and microwaves*. Living near Bumpus Ballpark, you'll have the best of Wasilla right at your doorstep, along with the ease of contemporary living at Amber Ridge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Bumpus Ballpark Wasilla AK",
      "seo_description": "Find apartments close to Bumpus Ballpark in Wasilla, AK at Amber Ridge. Enjoy modern living near your favorite ballpark.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167168",
      "source": "generator",
      "page_item_url": "crevasse-moraine-trailhead-apartments",
      "search_query": "Matanuska-Susitna Borough Crevasse-Moraine Trailhead apartments",
      "category": "Park",
      "h1_title": "Apartments Near Crevasse-Moraine Trailhead",
      "h2_subtitle": "Discover apartments close to Crevasse-Moraine Trailhead in Matanuska-Susitna Borough. Experience nature at your doorstep.",
      "page_copy": "Surround yourself with natural beauty at Amber Ridge Apartments, located near the Crevasse-Moraine Trailhead in Matanuska-Susitna Borough. Our community is perfect for outdoor enthusiasts looking to explore the scenic trails right in their backyard.\n\nAmber Ridge Apartments not only provides easy access to these amazing landscapes but also includes modern amenities like smoke-free living spaces, open grounds, and Energy Star Certified appliances such as dishwashers and microwaves*. Enjoy the tranquility of nature and the comforts of home at Amber Ridge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Crevasse-Moraine Trailhead",
      "seo_description": "Find apartments near Crevasse-Moraine Trailhead in Matanuska-Susitna Borough at Amber Ridge. Enjoy nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309350890"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082980"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "683bb3a2-a84e-420a-b14c-7f8208cda306"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/4bea420b-95a7-46c7-a9e2-28ab5e326e02/app.js?property=4bea420b-95a7-46c7-a9e2-28ab5e326e02&propertyName=Amber+Ridge&channelUuid=c248fbb9-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47708192305"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InFEMFV5cHpJTEtyMXZaR2dKTkFRbEE9PSIsInZhbHVlIjoiVW1heC9YdjhGV1NzVWlhZHRxMFREdz09IiwibWFjIjoiNzg5Mzg5NTcyNWZjY2ZiYTYyODUzYWUyZjFmNjMzNWFhZWM3MWM1NTBiMWJiYTE3MjI0YTNhNzc0ZTk5MDM4ZiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309350890",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082980",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "683bb3a2-a84e-420a-b14c-7f8208cda306",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/4bea420b-95a7-46c7-a9e2-28ab5e326e02/app.js?property=4bea420b-95a7-46c7-a9e2-28ab5e326e02&propertyName=Amber+Ridge&channelUuid=c248fbb9-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47708192305",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InFEMFV5cHpJTEtyMXZaR2dKTkFRbEE9PSIsInZhbHVlIjoiVW1heC9YdjhGV1NzVWlhZHRxMFREdz09IiwibWFjIjoiNzg5Mzg5NTcyNWZjY2ZiYTYyODUzYWUyZjFmNjMzNWFhZWM3MWM1NTBiMWJiYTE3MjI0YTNhNzc0ZTk5MDM4ZiJ9",
  "custom_audioeye_site_id": "fac84fd2-9035-4bb9-9737-075d0e1de1cb",
  "custom_audioeye_site_hash": "df3c94c0cee7158d690381d55aeb6c19"
};

export const generatedAt = '2026-11-02T18:12:14.672Z';
